var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copyright"},[_c('p',[_vm._v("© 四川富临蜜蜂出行科技有限公司")]),_c('p',[_vm._v("蜀ICP备16030281号-2 | 川公网安备 51010702001146号")]),_c('p',[_vm._v("增值电信业务经营许可证 川B2-20210736")])])
}]

export { render, staticRenderFns }